/**
 * The one checkbox appearance in the console.
 *
 * A native `<input type="checkbox">` renders at 13×13 CSS px in Chromium, which
 * is below WCAG 2.2 SC 2.5.8's 24×24 minimum and well below the 44px floor this
 * console holds its other controls to. A browser audit of the built console
 * found nine of them on a single content list — the row-selection column, which
 * is the affordance every bulk action depends on.
 *
 * The box itself is taken to 18px rather than to 24px: a 24px box in a compact
 * table row reads as a form field rather than as a selection mark. The TARGET is
 * enlarged separately, by the surrounding cell or label taking the click — see
 * `Table.tsx`, where the selection cell forwards its clicks to the input, so the
 * pointer target is the whole 44px-wide cell.
 */
export const CHECKBOX = 'h-[18px] w-[18px] shrink-0 accent-accent-blue';
